export default __webpack_public_path__ + "static/media/shopping-bag-icon.31e1f22d.svg";